import { FC } from "react";
import { useNavigate } from "react-router-dom";

export default function CardDashboard({
  title,
  icon: Icon,
  url,
  labelBtn,
}: {
  title: string;
  icon: FC<{ className?: string }>; // tipo per componenti icona (es. Heroicons)
  url: string;
  labelBtn: string;
}) {
    const navigate = useNavigate();

    return (
        <div className="flex">
        <div className="flex w-full max-w-full flex-col break-words rounded-lg border border-gray-100 bg-white text-gray-600 shadow-lg">
          <div className="p-3">
            <div className="absolute -mt-10 h-16 w-16 rounded-xl bg-gradient-to-tr from-emerald-700 to-emerald-500 text-center text-white shadow-lg">
              <Icon className="mt-4 h-7 w-16" />
            </div>
            <div className="pt-1 text-right">
              <p className="text-md font-light capitalize">{title}</p>
            </div>
          </div>
          <hr className="opacity-50" />
          <div className="p-4">
            <button className="text-[#064e3b] font-bold text-center" onClick={() => navigate(url)}>
                {labelBtn}
            </button>
          </div>
        </div>
      </div>
    )
}